import { useState } from "@wordpress/element";
import { COOKIE_ID } from "../constant";
import { cookies } from "../cookies";

function getter() {
	const cookie = cookies.get(COOKIE_ID);

	if (!cookie) {
		return [];
	}

	if (!Array.isArray(cookie)) {
		console.warn("Broken saved_offers cookie, not an array");
		return [];
	}

	return cookie;
}

function inCookie(offerID) {
	return getter().find((i) => i === String(offerID)) !== undefined;
}

export function useFavorite({ offerID }) {
	const [favorite, setFavorite] = useState(() => inCookie(offerID));

	function toggle() {
		if (inCookie(offerID)) {
			const filtered = getter().filter((i) => i !== String(offerID));
			cookies.set(COOKIE_ID, filtered);
			setFavorite(false);
		} else {
			cookies.set(COOKIE_ID, getter().concat(String(offerID)));
			setFavorite(true);
		}
	}

	return { favorite, toggle };
}
